import { render } from "./EmbargosPersonaCrearActualizarComponent.vue?vue&type=template&id=2b251055"
import script from "./EmbargosPersonaCrearActualizarComponent.vue?vue&type=script&lang=js"
export * from "./EmbargosPersonaCrearActualizarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__